import '../../styles/pages/common/commonPage.scss';
import { Routes, Route, Navigate } from 'react-router-dom';
import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import AgentsHub from './agents/AgentsHub';
import AgentSkillsTab from './agents/AgentSkillsTab';
import AgentBuilder from './agents/AgentBuilder';
import AgentSkillConfig from './agents/AgentSkillConfig';

/**
 * Agents hub (`/agents`; the old `/skills` path redirects here) — the
 * agent-skills surface.
 *
 * "Skills become agents": the hub is a card grid with a per-agent drawer
 * (`AgentsHub`), and Configure opens that agent's config on its own sub-page
 * (`AgentSkillConfig` at `/agents/:agentType`). This page owns the
 * outer chrome (PageWrapperMain → SubPageContentHolder) and is otherwise a thin
 * router; the landing and each config sub-page bring their own
 * `SubPageInnerContentHolder`. There is no installable-skill library any more
 * (removed 2026-09 together with the Skills→Agents rename).
 */
const Skills = () => {
  return (
    <PageWrapperMain>
      <div className='subPage'>
        <SubPageContentHolder>
          <Routes>
            <Route index element={<AgentsHub />} />
            {/* The agency-level Skills tab — a literal, declared before the
                dynamic `:agentType` config route so it can never be swallowed. */}
            <Route path='skills' element={<AgentSkillsTab />} />
            {/* "Build your own agent" (Agents v3) — literal, before `:agentType`. */}
            <Route path='new' element={<AgentBuilder />} />
            <Route path=':agentType' element={<AgentSkillConfig />} />
            <Route path='*' element={<Navigate to='/agents' replace />} />
          </Routes>
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default Skills;
